import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { ALL_DRAFT_INVOICES_QUERY_KEY } from "~/modules/billing/api/draftInvoice/draftInvoiceQueries.ts";
import { ALL_PROCESSED_INVOICES_QUERY_KEY } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import CreateNonProjectInvoiceForm
	from "~/modules/billing/components/InvoicePageHeader/components/CreateInvoiceSidebar/components/CreateNonProjectInvoiceForm";

type Props = {
	isOpen: boolean;
	onClose: () => void;
};

const CreateInvoiceSidebar = ({
	isOpen,
	onClose,
}: Props) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		queryClient.invalidateQueries({ queryKey: ALL_DRAFT_INVOICES_QUERY_KEY });
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		onClose();
	}, [onClose, queryClient]);




	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>

			{isOpen && <CreateNonProjectInvoiceForm onCancel={onClose}
													onSuccess={handleSuccess}
			/>}
		</Sidebar>
	);
};

export default CreateInvoiceSidebar;
